import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryAverageAttendanceInLibraryClasses = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Average attendance in library classes (%)" />
    </Box>
  );
};
